import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { ViewState } from '#components/Root/viewModel'
import type { Transitioner } from '#components/TransitionProvider'

import emailRegExp from 'email-regex'
import * as mobx from 'mobx'
import PT from 'prop-types'
import * as o from 'rxjs/operators'

import type { Pipedrive, LeadInfo } from '../../models/Pipedrive'

import { ATTRVALUE_DESTINATION_PIPEDRIVE } from '../../utils/constants'
import i18n from '../../utils/i18n'

export type Props = {
  state: ViewState
}

type Validator = Array<[(value: number) => boolean | null | undefined, string]>

export type ViewModel = {
  data: {
    company?: string
    name?: string
    requestEmail?: string
    telephone?: string
  }
  loading: boolean
  emailValidator: Validator
  phoneValidator: Validator
  isValid: boolean

  handleSend: () => void
  handleFormValid: (boolean) => void
  handleFormChange: (Object) => void
}

type Context = {
  models: { pipedrive: Pipedrive }
  transitioner: Transitioner
}

const mkViewModel = (
  { registerObservable }: Params,
  { state }: Props,
  { models: { pipedrive }, transitioner }: Context,
): ViewModel => {
  const attrs = transitioner.getAttributes()
  const user = attrs && attrs.user
  const vm = mobx.observable({
    data: user
      ? {
          name: user.fullName,
          requestEmail: user.email,
        }
      : null,
    loading: false,
    emailValidator: mobx.observable.ref([
      [
        (value) => emailRegExp({ exact: true }).test(value),
        i18n.translateWithoutTestId('Global.invalid-email'),
      ],
    ]),
    phoneValidator: mobx.observable.ref([
      [
        (value) =>
          value === null ||
          value === '' ||
          new RegExp('^[0-9-\+\(\) ]*$').test(value),
        i18n.translateWithoutTestId('Global.invalid-phone'),
      ],
    ]),

    isValid: false,
    handleSend: mobx.action(() => {
      vm.loading = true
      const nextNodeId =
        state.currentNode &&
        state.currentNode.nextNode &&
        state.currentNode.nextNode.id
      const values = transitioner.getValueCollection()
      if (values.destination === ATTRVALUE_DESTINATION_PIPEDRIVE) {
        const payload: LeadInfo = {
          ...values,
          ...vm.data,
          customValues: { ...state.customAttributesObject },
        }
        registerObservable(
          pipedrive.createLead(payload).pipe(
            o.tap(() => {
              vm.loading = false
              if (nextNodeId) transitioner.goForward(nextNodeId)
            }),
          ),
        )
      }
    }),
    handleFormValid: mobx.action((isValid) => {
      // @ts-expect-error@2322
      vm.isValid = isValid
    }),
    handleFormChange: mobx.action((values) => {
      // @ts-expect-error@2339
      const { name, requestEmail, telephone, company } = values
      // @ts-expect-error@2353
      vm.data = { name, requestEmail, telephone, company }
    }),
  })

  // @ts-expect-error@2322
  return vm
}

mkViewModel.contextTypes = {
  models: PT.object.isRequired,
  transitioner: PT.object.isRequired,
}

export default mkViewModel
